export type ParticipantStatusName =
    | 'Accepted'
    | 'Waitlist'
    | 'Declined'
    | 'Cancelled'
    | 'Attended'
    | 'NoShow'
    | 'AttestationPending'
    | 'AttestationRejected'
    | 'Deleted';

export type StatusFilter = ParticipantStatusName | '';

// Order of the status tabs in the legacy guest list.
export const STATUS_FILTERS: { status: StatusFilter; attestationOnly?: boolean }[] = [
    { status: '' },
    { status: 'Accepted' },
    { status: 'AttestationPending', attestationOnly: true },
    { status: 'AttestationRejected', attestationOnly: true },
    { status: 'Waitlist' },
    { status: 'Declined' },
    { status: 'Cancelled' },
    { status: 'Attended' },
    { status: 'NoShow' },
];

// Order of the per-row status dropdown in the legacy guest list.
export const ROW_STATUS_OPTIONS: { status: ParticipantStatusName; attestationOnly?: boolean }[] = [
    { status: 'Accepted' },
    { status: 'Waitlist' },
    { status: 'Declined' },
    { status: 'Cancelled' },
    { status: 'Attended' },
    { status: 'NoShow' },
    { status: 'AttestationPending', attestationOnly: true },
    { status: 'AttestationRejected', attestationOnly: true },
];

export const ORDER_BY_FIELDS = ['Status', 'FirstName', 'LastName', 'Email', 'SmsNumber', 'CompanyName', 'Created', 'Modified'] as const;
export type OrderByField = (typeof ORDER_BY_FIELDS)[number];
export type OrderDirection = 'asc' | 'desc';

export const DEFAULT_PAGE_SIZE = 25;

export interface EventParticipant {
    EventParticipantId: string;
    EventParticipantParentId: string | null;
    EventId: string;
    ContactId: string | null;
    FirstName: string | null;
    LastName: string | null;
    Email: string | null;
    SmsNumber: string | null;
    CompanyName: string | null;
    /** Raw JSON string written by the sign-up form. */
    EventParticipantData: string | null;
    Created: string;
    Modified: string;
    StatusName: ParticipantStatusName;
    SurveyResponseId: string | null;
    HasChildren: boolean;
    AttestationEventParticipant: { ReminderSent: string | null } | null;
}

export interface ParticipantsResult {
    Results: EventParticipant[];
    Count: number;
}

export interface ParticipantDataField {
    Title?: string;
    DefaultValue?: string;
    Value?: string;
}

/** Parsed EventParticipantData — for primary guests it carries the accompanying guests in Participants. */
export interface ParticipantData {
    Sqiid?: string | number;
    Name?: string;
    FirstName?: string;
    LastName?: string;
    Email?: string;
    SmsNumber?: string;
    CompanyName?: string;
    Fields?: ParticipantDataField[];
    Participants?: ParticipantData[];
    [key: string]: unknown;
}

export type GuestRowKind = 'primary' | 'child' | 'orphanChild';

export interface GuestRow {
    /** EventParticipantId, flattened so the shared List can key and select rows by it. */
    id: string;
    participant: EventParticipant;
    data: ParticipantData;
    kind: GuestRowKind;
}

export interface FullParticipantStatus {
    All: number;
    Accepted: number;
    Waitlist: number;
    Declined: number;
    Cancelled: number;
    Attended: number;
    NoShow: number;
    AttestationPending: number;
    AttestationRejected: number;
}
